var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Playlist__Icn/40px/Playlist",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Playlist__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Playlist__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,24 C23.5,22.4176684 25.2504919,21.4619852 26.5815152,22.317643 L33.5815152,26.817643 C34.8061616,27.6049157 34.8061616,29.3950843 33.5815152,30.182357 L26.5815152,34.682357 C25.2504919,35.5380148 23.5,34.5823316 23.5,33 Z M25.5,24 L25.5,33 L32.5,28.5 L25.5,24 Z M27,5 C28.1045695,5 29,5.8954305 29,7 L29,20 L27,20 L27,7 L11,7 L11,29 L20.004,29 L20.005,31 L11,31 C9.8954305,31 9,30.1045695 9,29 L9,7 C9,5.8954305 9.8954305,5 11,5 L27,5 Z M19,18 L19,20 L13,20 L13,18 L19,18 Z M25,14 L25,16 L13,16 L13,14 L25,14 Z M25,10 L25,12 L13,12 L13,10 L25,10 Z",
    id: ".._.._src_svg_Icn_40px_Playlist__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/Playlist.9cd3fa7627e0718398ce4bb87de07dff.svg";
export { ForwardRef as ReactComponent };